import { useCallback, useEffect, useMemo, useState } from 'react';
import { Dropdown, Button } from 'antd';

import { useAppDispatch, useAppSelector } from '@store/store.tsx';
import { startTour } from '@store/slices/tourSlice.tsx';
import { getValidTourSteps, scrollToFirstElement } from '@features/eshop/components/tours/Utils.tsx';
import type { TourStep } from '@app-types/tour.types.ts';

import {   faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

import './float-buttons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const HelpFloatButton = () => {
  const dispatch = useAppDispatch();
  const stepsRawList = useAppSelector((state) => state.tour?.stepsRawList ?? {});
  const [validTours, setValidTours] = useState<Array<{ tourName: string; stepsRaw: TourStep[] }>>([]);

  useEffect(() => {
    const toursWithValidSteps = Object.entries(stepsRawList)
      .map(([tourName, stepsRaw]) => {
        const validSteps = getValidTourSteps(stepsRaw ?? []) ?? [];
        return { tourName, stepsRaw: validSteps };
      })
      .filter((tour) => tour.stepsRaw.length > 0);

    setValidTours(toursWithValidSteps);
  }, [stepsRawList]);

  const handleTourSelection = useCallback(
    async (stepsRaw: TourStep[]) => {
      const validSteps = getValidTourSteps(stepsRaw) ?? stepsRaw;
      await scrollToFirstElement(validSteps);
      dispatch(startTour({ steps: validSteps }));
    },
    [dispatch],
  );

  const menuItems = useMemo(
    () =>
      validTours.map(({ tourName, stepsRaw }) => ({
        key: tourName,
        label: tourName,
        icon: <i className="fa-solid fa-location-arrow" aria-hidden />, 
        onClick: () => handleTourSelection(stepsRaw),
      })),
    [validTours, handleTourSelection],
  );

  if (menuItems.length === 0) {
    return null;
  }

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="topRight">
      <Button
        type="default"
        shape="circle"
        className="float-button float-button--ghost"
        aria-label="Iniciar tour guiado"
      >
        {/*<FontAwesomeIcon icon={faCircleQuestion} aria-hidden style={{ fontSize: 'clamp(56px, 96cqi)' }} />*/}
        <FontAwesomeIcon icon={faCircleQuestion} aria-hidden style={{ fontSize: '48px' }} />
        {/*<i className="fa-solid fa-circle-question" aria-hidden style={{ fontSize: 24 }} />*/}
      </Button>
    </Dropdown>
  );
};

export default HelpFloatButton;
